import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import useIsMobile from 'components/program-marketing/useIsMobile'
import makeStyles from '@material-ui/core/styles/makeStyles'

const colors = {
  white: 'light',
  blue: 'dark',
  tan: 'main',
}

const useStyles = makeStyles(theme => ({
  container: {
    background: props => theme.palette.background[colors[props.color]],
  },
}))

export default function ({ children, fullWidth, color = 'white', ...props }) {
  const isMobile = useIsMobile()
  const classes = useStyles({ color })

  return (
    <Box
      px={isMobile ? 4 : 16}
      py={isMobile ? 6 : 12}
      className={classes.container}
      {...props}
    >
      <Grid>
        <Grid item sm={12} md={fullWidth ? 12 : 8}>
          {children}
        </Grid>
      </Grid>
    </Box>
  )
}
